<template>
  <div class="home bg-beige-200">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->

    <Navigation> </Navigation>

    <Meldungen> </Meldungen>

    <Geschichte> </Geschichte>

    <Cookie> </Cookie>

    <FooterVue> </FooterVue>

  </div>
</template>

<script>
// @ is an alias to /src
import Navigation from '@/components/Navigation.vue'
import FooterVue from '@/components/FooterVue.vue'
import Meldungen from '@/components/Meldungen.vue'
import Cookie from '@/components/Cookie.vue'
import Geschichte from '@/components/Geschichte.vue'

export default {
  name: 'geschichte',

  components: {
    Navigation,
    FooterVue,
    Meldungen,
    Cookie,
    Geschichte
  },

  methods: {

    onload: function () {
      this.$store.dispatch('initialfetch');
    },

    matchHeight() {

      setInterval(function(){

        let insideheight = this.$refs.wandern.clientHeight;

        this.$store.commit('updateheight', insideheight);

      }.bind(this), 500);

    }

  },
  mounted: function(){

    this.onload();
    this.matchHeight();

  },

  computed: {

  }

}
</script>

<style media="screen">

</style>
